import React, { useCallback, useState } from 'react';

import Button, { BUTTON_TYPES, BUTTON_WIDTHS } from 'buyside/components/presentation/Button/button';
import Modal from 'buyside/components/presentation/Modal/modal';

import {
  useCreateBlocklistEntryMutation,
  useDestroyBlocklistEntryMutation
} from 'interfaces/graphql-typings';

import styles from './AllocatorBlocklistToggleModalStyles.scss';

const AllocatorBlocklistToggleModal: React.FC<{
  allocatorProfileId: string;
  fundName: string;
  fundProfileId: string;
  isBlocklisted: boolean;
}> = ({ allocatorProfileId, fundName, fundProfileId, isBlocklisted }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [
    handleCreateBlocklistEntry,
    { loading: createBlocklistEntryLoading }
  ] = useCreateBlocklistEntryMutation({
    variables: { allocatorProfileId, employerProfileId: fundProfileId },
    update: cache =>
      cache.modify({
        id: `EmployerProfile:${fundProfileId}`,
        fields: {
          isAllocatorBlocklisted: () => true
        }
      })
  });

  const [
    handleDestroyBlocklistEntry,
    { loading: destroyBlocklistEntryLoading }
  ] = useDestroyBlocklistEntryMutation({
    variables: { allocatorProfileId, employerProfileId: fundProfileId },
    update: cache =>
      cache.modify({
        id: `EmployerProfile:${fundProfileId}`,
        fields: {
          isAllocatorBlocklisted: () => false
        }
      })
  });

  const buttonText = isBlocklisted
    ? `Remove from ${fundName}'s Blocklist`
    : `Add to ${fundName}'s Blocklist`;

  const renderOpenModalButton = useCallback(
    () => (
      <Button
        className={styles.blocklistToggleModalLink}
        onClick={() => setIsModalOpen(true)}
        text={buttonText}
        type={BUTTON_TYPES.LINK}
      />
    ),
    [buttonText]
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      renderOpenModalButton={renderOpenModalButton}
      title={buttonText}
    >
      <div>
        <h5>What is an Allocator Blocklist?</h5>
        <p>
          Allocators you add to this list cannot see the sections on your Fund's Profile specified
          for "Filtered Allocators".
        </p>
        <h5>How do I manage the complete list?</h5>
        <p>Navigate to Your Fund's Profile, and click on the "Manage Your Fund's Blocklist" link</p>
      </div>
      <Button
        id="allocator-blocklist-toggle-button"
        isLoading={createBlocklistEntryLoading || destroyBlocklistEntryLoading}
        onClick={isBlocklisted ? handleDestroyBlocklistEntry : handleCreateBlocklistEntry}
        text={buttonText}
        type={isBlocklisted ? BUTTON_TYPES.DANGER : BUTTON_TYPES.MAJOR}
        width={BUTTON_WIDTHS.FULL}
      />
    </Modal>
  );
};

export default AllocatorBlocklistToggleModal;
